module.exports = __webpack_public_path__ + "img/vaultspay.5ab42c18.png";